import React from "react";
import { HelpBoardList, PostForm } from '../HelpBoardList/index';

function HelpBoardPage() {
  return (
    <div>
      <HelpBoardList />
      {/* <PostForm /> */}
    </div>
  );
}

export default HelpBoardPage;
